import React from "react";
import "./App.css";
import styled from "styled-components";
import { SCREENS } from "./app/components/components/responsive";
import TopNav from "./app/components/navbar/topNav";
import HomePage from "./app/pages/HomePage";
import LeftNav from "./app/components/navbar/leftNav";
import Paper from "./app/components/components/paper";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./app/pages/Login";
import Register from "./app/pages/Register";
import Download from "./app/pages/Download";
import { useMediaQuery } from "react-responsive";
import Sidebar from "./app/components/navbar/sidebar";
import Search from "./app/pages/Search";
import TheGame from "./app/pages/TheGame";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AppContainer = styled.div`
  width: 100%;
  max-width: ${SCREENS.xl};
  margin-top: 20px;
  padding: 5px;
`;

const AppInnerContainer = styled.div`
  display: flex;
`;

const LeftColumn = styled.div`
  min-width: 180px;
`;

function App() {
  const isMobile = useMediaQuery({
    maxWidth: SCREENS.md,
  });

  return (
    <>
      <Router>
        <AppContainer>
          <TopNav />
          <AppInnerContainer>
            {!isMobile ? (
              <LeftColumn>
                <LeftNav />
              </LeftColumn>
            ) : (
              <Sidebar>
                <LeftNav />
              </Sidebar>
            )}

            <Paper>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/download" element={<Download />} />
                <Route path="/search" element={<Search />} />
                <Route path="/game" element={<TheGame />} />
              </Routes>
            </Paper>
          </AppInnerContainer>
        </AppContainer>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
